// path/to/SignUpContainer.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ref, get } from 'firebase/database';
import generateAPIKey from './APIGenerator'; // Import the API generator function
import { writeUserData } from './Users';
import { createCredits } from './Credits';
import { database } from '../firebaseConfig';

function SignUpContainer() {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState(''); // Add state for error message
    const navigate = useNavigate();

    const handleSignUp = () => {
        if (!username || !email || !password) {
            setErrorMessage('All fields are mandatory'); // Set error message
            return;
        } else {
            setErrorMessage(''); // Clear error message on successful validation
        }

        // Check if email already exists in the Users database
        const sanitizedEmail = email.replace(/[.#$[\]]/g, '_'); // Sanitize the email to create a valid path
        const userRef = ref(database, 'Users'); // Reference to the Users table
        get(userRef).then((snapshot) => {
            const emailExists = snapshot.val() && Object.values(snapshot.val()).some(user => user.EmailAddress === sanitizedEmail); // Check if any user has the same EmailAddress
            if (emailExists) {
                setErrorMessage('Email already in use'); // Set error message if email exists
                return;
            } else {
                // Proceed with sign-up logic
                const userId = '1234'
                const SignInType = 'Custom Sign In'
                const createdAt = Date.now()
                const API_KEY = generateAPIKey();
                writeUserData(userId, sanitizedEmail, username, password, SignInType, createdAt, API_KEY); // Insert record in Users table
                //console.log('New user added to the database');
                navigate('/DashboardPage');
                // Create a record in the Credits table
                try {
                    const initialCredits = createCredits(userId);
                    //console.log('Credits record created successfully:', initialCredits);
                } catch (creditsError) {
                    //console.error('Error creating credits record:', creditsError);
                    setErrorMessage(`Failed to create credits record: ${creditsError.message}`); // Changed setError to setErrorMessage
                    return; // Prevent navigation if credits record creation fails
                }
            }
        }).catch((error) => {
            setErrorMessage('Error checking email: ' + error.message); // Handle errors
        });

        // Validate email format
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
            setErrorMessage('Please enter a valid email address'); // Set error message for invalid email
            return;
        }

        // Validate password complexity
        const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        if (!passwordPattern.test(password)) {
            setErrorMessage('Password must be at least 8 characters. Use 1 uppercase, 1 lowercase, 1 number, and 1 special character.');
            //setErrorMessage(''); // Set error message for invalid password
            return;
        }
    };

    return (
        <div className="sign-up-container">
            <div style={customSignUpBoxStyle}>
                <h2>Sign Up</h2>
                <input 
                    type="text" 
                    placeholder="Username" 
                    value={username} 
                    onChange={(e) => setUsername(e.target.value)} 
                    style={inputStyle} 
                />
                <input 
                    type="email" 
                    placeholder="Email Address" 
                    value={email} 
                    onChange={(e) => setEmail(e.target.value)} 
                    style={inputStyle} 
                />
                <input 
                    type="password" 
                    placeholder="Password" 
                    value={password} 
                    onChange={(e) => setPassword(e.target.value)} 
                    style={inputStyle} 
                />
                <button 
                    style={loginButtonStyle} 
                    onClick={handleSignUp}
                >
                    Sign Up
                </button>
                {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>} {/* Display error message */}
            </div>
        </div>
    );
}

const customSignUpBoxStyle = {
    display: 'flex', // Add flex display
    flexDirection: 'column', // Stack children vertically
    justifyContent: 'center', // Center children vertically
    alignItems: 'center', // Center children horizontally
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    width: '100%',
    maxWidth: '280px',
    margin: '0 20px', // Added margin to create space around the custom login box
    position: 'absolute', // Added to position the box
    top: '50%', // Center vertically
    left: '50%', // Center horizontally
    transform: 'translate(-50%, -50%)', // Adjust position to truly center
};

const loginButtonStyle = {
    backgroundColor: '#34A853', // Changed to green
    color: '#fff',
    padding: '8px',
    border: 'none',
    borderRadius: '4px',
    width: '100%',
    fontSize: '14px',
    cursor: 'pointer',
    marginTop: '10px',
};

const inputStyle = {
    width: '100%',
    padding: '10px',
    margin: '10px 0',
    border: '1px solid #ccc',
    borderRadius: '4px',
};

export default SignUpContainer;
